import { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useQueryClient } from '@tanstack/react-query'

import { ApiUrlPath, IQuestion } from 'cat-shared/utils'
import { AppButton } from 'client/ui-building-blocks'
import { useCreateQuestion } from 'client/api'

import { type TGetProposedQuestionsData, useDeleteProposedQuestions } from '../../api'

type Props = {
  question: IQuestion
  disabled: boolean
}

export const AcceptButton = ({ question, disabled }: Props) => {
  const queryClient = useQueryClient()

  const [loading, setLoading] = useState<boolean>(false)

  const { mutateAsync: createQuestion } = useCreateQuestion()
  const { mutateAsync: deleteProposedQuestions } = useDeleteProposedQuestions()

  const { getValues } = useFormContext()

  const questionId = question._id.toString()

  const onAcceptBtnClick = async () => {
    setLoading(true)
    await createQuestion({
      ...question,
      category: getValues().category,
    })
    await deleteProposedQuestions({ questionIds: [questionId] })

    queryClient.setQueryData(
      [ApiUrlPath.GetProposedQuestions],
      ({ count, data }: TGetProposedQuestionsData) => {
        return {
          count: count - 1,
          data: data.filter(item => item._id !== questionId),
        }
      }
    )

    setLoading(false)
  }

  return useMemo(() => {
    return (
      <AppButton
        variant="success"
        text="Accept"
        onClick={onAcceptBtnClick}
        loading={loading}
        disabled={disabled}
      />
    )
  }, [loading, disabled])
}
